import React from 'react';
import { RouterProvider } from 'react-router-dom';
import router from 'src/routes';

const App = () => <RouterProvider router={router} />;

export default App;
